module.exports = __webpack_public_path__ + "img/companyImg.f62b7999.png";